<iframe #iframeElement
  referrerpolicy="no-referrer"
  loading="lazy"
  [src]="attributes.src | safe: 'resourceUrl'"
  [attr.height]="(iframeHeight$ | async) || attributes.initialHeight"
></iframe>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
